export default __webpack_public_path__ + "static/media/eth_icon_blue.78c9dd36.svg";